export const Actions = {
  ingredientGot: 'INGREDIENTS_GOT',
  ingredientAdded: 'INGREDIENT_ADDED',
  ingredientRemoved: 'INGREDIENT_REMOVED',

  orderSendingState: 'ORDER_SENDING_STATE',
  orderSentSuccess: 'ORDER_SENT_SUCCESS',
  orderSentFail: 'ORDER_SENT_FAIL',

  errorOccurred: 'ERROR_OCCURRED',
  errorRemoved: 'ERROR_REMOVED',

  userSignIn: 'USER_SIGN_IN',
  userSighOut: 'USER_SIGN_OUT',
  userInitiateSighOut: 'USER_INITIATE_SIGH_OUT',
};
